"use strict";

export function initInScope ($scope) {

    $scope.find('.js-collapsing-persons__input').on('change',function (e) {
        $(this).closest('.js-collapsing-persons').find('.js-collapsing-persons__add').attr('hidden','hidden');
        if ($(this).closest('.js-collapsing-persons').find('.js-collapsing-persons__input--toggler').prop('checked')) {
            $(this).closest('.js-collapsing-persons').find('.js-collapsing-persons__add').removeAttr('hidden');
        }
    });
}